var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: {
        value: _vm.showModal,
        title: "On-demand Import",
        "header-close-btn": true
      },
      on: { hide: _vm.onCancel, input: _vm.updateShowModal }
    },
    [
      _vm.importStatus.loading
        ? _c("div", { staticClass: "alert alert-info" }, [
            _c("p", [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Initiating on-demand import...")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.importStatus.success
        ? _c("div", { staticClass: "alert alert-success" }, [
            _c("p", [
              _c("i", { staticClass: "fa fa-check-circle" }),
              _vm._v(" On-demand import initiated successfully!")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Import ID: " + _vm._s(_vm.importStatus.importUuid))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.importStatus.error
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("p", [
              _c("i", { staticClass: "fa fa-exclamation-circle" }),
              _vm._v(" Error initiating on-demand import:")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.importStatus.errorMessage))])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.importStatus.loading &&
      !_vm.importStatus.success &&
      !_vm.importStatus.error
        ? _c("div", [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.options.autocommit,
                        expression: "options.autocommit"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.options.autocommit)
                        ? _vm._i(_vm.options.autocommit, null) > -1
                        : _vm.options.autocommit
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.options.autocommit,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.options,
                                "autocommit",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.options,
                                "autocommit",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.options, "autocommit", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Auto-commit Import")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help-block" }, [
                  _vm._v(
                    "\n          When enabled, imported user changes will automatically be saved.\n        "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.options.deactivate_missing,
                        expression: "options.deactivate_missing"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.options.deactivate_missing)
                        ? _vm._i(_vm.options.deactivate_missing, null) > -1
                        : _vm.options.deactivate_missing
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.options.deactivate_missing,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.options,
                                "deactivate_missing",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.options,
                                "deactivate_missing",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.options, "deactivate_missing", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Deactivate Missing Users")])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help-block" }, [
                  _vm._v(
                    "\n          When enabled, users not present in the import will be automatically deactivated.\n        "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.options.autoupdate_titles,
                        expression: "options.autoupdate_titles"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.options.autoupdate_titles)
                        ? _vm._i(_vm.options.autoupdate_titles, null) > -1
                        : _vm.options.autoupdate_titles
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.options.autoupdate_titles,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.options,
                                "autoupdate_titles",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.options,
                                "autoupdate_titles",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.options, "autoupdate_titles", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v("Auto-update titles with provider data")
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help-block" }, [
                  _vm._v(
                    "\n          When enabled, users will receive titles from the provider. When disabled, users will keep local titles.\n        "
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { type: "button" },
            on: { click: _vm.onCancel }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        !_vm.importStatus.loading &&
        !_vm.importStatus.success &&
        !_vm.importStatus.error
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: _vm.importStatus.loading },
                on: { click: _vm.startImport }
              },
              [
                _c("i", { staticClass: "fa fa-play" }),
                _vm._v("\n      Begin Import\n    ")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.importStatus.success || _vm.importStatus.error
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: () => {
                    _vm.resetStatus()
                    _vm.updateShowModal(false)
                  }
                }
              },
              [_vm._v("\n      Close\n    ")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }